import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M6.78921 8.74899L1.99187 3.03641C1.50012 2.45085 1.91642 1.55762 2.68108 1.55762H16.7187C17.4995 1.55762 17.9099 2.48387 17.3853 3.06226L12.2334 8.74271C12.0832 8.90829 12 9.12382 12 9.34735V17.4129C12 18.1119 11.2379 18.5441 10.638 18.1852L7.43797 16.2709C7.16631 16.1084 7 15.8151 7 15.4986V9.32778C7 9.11606 6.92536 8.91112 6.78921 8.74899Z",
      stroke: "white",
      "stroke-width": "1.5"
    }, null, -1)
  ]))]))
}
export default { render: render }